import React from 'react'
import { Button } from 'sdc-react-basics'

export const CloneButton = ({style,...params}) => (
  <Button icon="clone" style={{color: '#009', ...style}} {...params} />
)
